import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { IProcedureCode } from 'interfaces/services';
import { loadSelectedClinicId } from 'utils/storage';

interface IUseServiceProcedureCodesParams {
  shouldRun?: boolean;
}

const useServiceProcedureCodes = ({
  shouldRun,
}: IUseServiceProcedureCodesParams) => {
  const clinicId = loadSelectedClinicId();
  const url = `clinics/${clinicId}/procedures`;

  const { data, error, mutate } = useSWR<IProcedureCode[]>(
    shouldRun ? [url] : false,
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get(url);
      return response.data;
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};

export default useServiceProcedureCodes;
